module.exports = __webpack_public_path__ + "images/emoji/information_desk_person.ce447ab71dd2706e67eb.png";